<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37">
  <path id="ic_stars_24px" d="M20.481,2A18.5,18.5,0,1,0,39,20.5,18.491,18.491,0,0,0,20.481,2Zm7.844,29.6L20.5,26.882,12.675,31.6l2.072-8.9-6.9-5.976,9.1-.777L20.5,7.55l3.552,8.381,9.1.777-6.9,5.976Z" transform="translate(-2 -2)" fill="#F9850C"/>
</svg>

</template>

<script>
export default {

}
</script>

<style>

</style>